import type { ConversationKind } from '../types';
import type { MessageKindAdapter } from './types';
import directAdapter from './direct';
import proposalAdapter from './proposal';
import invitationAdapter from './invitation';
import systemAdapter from './system';

/**
 * Adapter registry — 신규 kind 추가 시 모듈 import + 한 줄 등록만으로 확장.
 * 백엔드 dispatcher(`computeSideEffects` / lifecycle table) 와 1:1 거울.
 */
const REGISTRY: Record<ConversationKind, MessageKindAdapter> = {
 direct: directAdapter,
 proposal: proposalAdapter,
 invitation: invitationAdapter,
 system: systemAdapter,
};

export function getAdapter(kind: ConversationKind): MessageKindAdapter {
 return REGISTRY[kind] ?? systemAdapter;
}
